import { ComposeEditorType } from './schema/ComposeEditorType';
import { PreferredEditorMap } from './schema/PreferredEditorMap';
import { isConfigValid } from './isConfigValid';
import BodyType from 'owa-service/lib/contract/BodyType';

const LOCALSTORAGE_KEY = 'compose.PREFERRED_EDITORS';

export const defaultPreferredEditorTypes: PreferredEditorMap = {
    Text: ComposeEditorType.Textarea,
    HTML: ComposeEditorType.RoosterHTML,
};

export const editorToBodyType: { [key in ComposeEditorType]: BodyType } = {
    [ComposeEditorType.Textarea]: 'Text',
    [ComposeEditorType.RoosterHTML]: 'HTML',
    [ComposeEditorType.RawContentEditableDivHTML]: 'HTML',
};

let preferredEditorTypes: PreferredEditorMap = null;

export function getDefaultPreferredEditorTypes(): PreferredEditorMap {
    // Initialize from localStorage if unavailable
    if (preferredEditorTypes === null) {
        preferredEditorTypes = initializePreferredEditorType() || {
            ...defaultPreferredEditorTypes,
        };
    }
    return { ...preferredEditorTypes };
}

function initializePreferredEditorType(): PreferredEditorMap {
    try {
        const config = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY));
        if (!isConfigValid(config)) {
            return null;
        }
        return config;
    } catch (e) {
        return null;
    }
}

export function setPreferredEditorTypeInStorage(
    bodyContentType: BodyType,
    composeEditorType: ComposeEditorType
): void {
    preferredEditorTypes[bodyContentType] = composeEditorType;
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(preferredEditorTypes));
}
